var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
let Page7 = class Page7 extends Vue {
};
__decorate([
    Getter
], Page7.prototype, "page7", void 0);
__decorate([
    State
], Page7.prototype, "defaultImg", void 0);
Page7 = __decorate([
    Component
], Page7);
export default Page7;
